import { render, staticRenderFns } from "./cryptoSelector.vue?vue&type=template&id=f6f675ae"
import script from "./cryptoSelector.vue?vue&type=script&lang=js"
export * from "./cryptoSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports